import {AssetDueDateService} from '../../services/asset-due-date.service';
import {Component, HostListener, OnInit} from '@angular/core';
import {ThemeConstantService} from '../../services/theme-constant.service';
import {AuthenticationService} from '../../services/authentication.service';
import {User} from '../../../../../../database-models';
import {InvoiceDuesService} from '../../services/invoice-dues.service';
import {ApiService} from '../../../services/api.service';
import {MessageService} from '../../services/message.service';
import {GlobalSearchComponent, ModalData as GlobalSearchModalData} from "../../components/global-search/global-search/global-search.component";
import {NzModalService} from "ng-zorro-antd/modal";
import {environment} from "../../../../environments/environment";
import {TicketService} from '../../services/ticket.service';
import {TimetrackingService} from "../../services/timetracking.service";
import {NewContractAlertComponent} from "../../components/new-contract-alert/new-contract-alert.component";
import {IntervalPlanService} from '../../services/interval-plan.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent implements OnInit {

  searchVisible = false;
  quickViewVisible = false;
  isFolded: boolean;
  isExpand: boolean;
  public user: User;
  public backendURL = environment.apiURL;

  private lastRefresh = 0;

  @HostListener('document:visibilitychange')
  onVisibilityChange() {
    if (!document.hidden) {
      const now = Date.now();
      if (now - this.lastRefresh > 10_000) { // max. 1x pro 10 Sekunden
        this.lastRefresh = now;
        this.timeService.getEmployeeTimestamps();
      }
    }
  }

  constructor(private themeService: ThemeConstantService,
              public authservice: AuthenticationService,
              private api: ApiService,
              private message: MessageService,
              private modalService: NzModalService,
              public timeService: TimetrackingService,
              public ticketService: TicketService,
              public ips: IntervalPlanService,
              public assetDueDates: AssetDueDateService,
              public invoiceDues: InvoiceDuesService
  ) {
    this.authservice.currentUserSubject.subscribe(user => {
      this.user = user;
    });
    this.authservice.loadCurrentUserOnce().then(user => this.user = user);
    setTimeout(() => {
      this.checkNewContract();
    }, 1000);

    setInterval(() => {
      this.getCurrentUser();
    }, 300000);
  }

  public getCurrentUser(): void {
    this.api.getMe().subscribe((user: User) => {
      this.authservice.setCurrentUser(user);
      this.user = user;


    /*  // @ts-ignore
      zE('messenger', 'loginUser', function (callback) {
        callback(user.jwt);
      });
      localStorage.setItem('zJWT', user.jwt);*/


    }, onerror => {
      console.log(onerror);
    });

  }

  public checkNewContract(): void {
    let user = this.user;
    console.log(user?.company?.billing.oldCustomer, !user?.company?.billing.acceptedNewContract)
    if (user?.company?.billing) {
      if (user?.isAdmin && user?.company?.billing.oldCustomer && !user?.company?.billing.acceptedNewContract) {
        this.modalService.create({
          nzContent: NewContractAlertComponent,
          nzWidth: '800px',
          nzFooter: null,
          nzMaskClosable: false,
          nzClosable: false,
        })
      }
    }
  }

  /** Summe aller offenen Rechnungen im Banner (brutto), damit der Kunde den Gesamtbetrag direkt überweisen kann */
  public get overdueInvoicesTotal(): number {
    return this.invoiceDues.total(this.user?.overdueInvoices);
  }

  public get overdueFeesTotal(): number {
    return this.invoiceDues.feesTotal(this.user?.overdueInvoices);
  }

  ngOnInit(): void {
    this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
    this.ips.loadOverdueSummary();
    this.assetDueDates.loadSummary();
    setInterval(() => {
      this.ips.loadOverdueSummary();
      this.assetDueDates.loadSummary();
    }, 300000);
  }

  toggleFold() {
    this.isFolded = !this.isFolded;
    this.themeService.toggleFold(this.isFolded);
  }

  toggleExpand() {
    this.isFolded = false;
    this.isExpand = !this.isExpand;
    this.themeService.toggleExpand(this.isExpand);
    this.themeService.toggleFold(this.isFolded);
  }

  quickViewToggle(): void {
    this.quickViewVisible = !this.quickViewVisible;
  }


  public globalSearch(): void {
    const newObjectModal = this.modalService.create<GlobalSearchComponent, GlobalSearchModalData>({
      nzContent: GlobalSearchComponent,
      nzData: {
        hideLinkTaskBtn: false,
        hideLinkTicketBtn: false,
        showInfotxt: true,
        showSearchFilter: true,
        searchPlaceholder: 'Globale Suche nach Aufgaben, Kunden, Konakte und Tickets'
      },
      nzWidth: '1150px',
      nzFooter: null,
      nzCloseIcon: ''
    });
    newObjectModal.afterClose.subscribe((data: any) => {
    });
  }

  public toggleChat(): void {
    //@ts-ignore
    window.$chatwoot.toggle('open')
  }

  protected readonly window = window;
}
